export default {"src":"/_next/static/media/light-purple-to-dark-purple-right.7d2d4fb1.svg","height":220,"width":1920,"blurWidth":0,"blurHeight":0};